import { Box, SxProps, Theme } from '@mui/material';
import { CantonAbbr } from 'domain/types/location/cantons';
import React from 'react';
import AargauFlag from '../../../assets/images/cantons/AG.svg';
import AppenzellInnerrhodenFlag from '../../../assets/images/cantons/AI.svg';
import AppenzellAusserrhodenFlag from '../../../assets/images/cantons/AR.svg';
import BernFlag from '../../../assets/images/cantons/BE.svg';
import BaselLandschaftFlag from '../../../assets/images/cantons/BL.svg';
import BaselStadtFlag from '../../../assets/images/cantons/BS.svg';
import EmptyFlag from '../../../assets/images/cantons/empty.svg';
import FribourgFlag from '../../../assets/images/cantons/FR.svg';
import GeneveFlag from '../../../assets/images/cantons/GE.svg';
import GlarusFlag from '../../../assets/images/cantons/GL.svg';
import GraubundenFlag from '../../../assets/images/cantons/GR.svg';
import JuraFlag from '../../../assets/images/cantons/JU.svg';
import LuzernFlag from '../../../assets/images/cantons/LU.svg';
import NeuchatelFlag from '../../../assets/images/cantons/NE.svg';
import NidwaldenFlag from '../../../assets/images/cantons/NW.svg';
import ObwaldenFlag from '../../../assets/images/cantons/OW.svg';
import StGallenFlag from '../../../assets/images/cantons/SG.svg';
import SchaffhausenFlag from '../../../assets/images/cantons/SH.svg';
import SolothurnFlag from '../../../assets/images/cantons/SO.svg';
import SchwyzFlag from '../../../assets/images/cantons/SZ.svg';
import ThurgauFlag from '../../../assets/images/cantons/TG.svg';
import TicinoFlag from '../../../assets/images/cantons/TI.svg';
import UriFlag from '../../../assets/images/cantons/UR.svg';
import VaudFlag from '../../../assets/images/cantons/VD.svg';
import WallisFlag from '../../../assets/images/cantons/VS.svg';
import ZugFlag from '../../../assets/images/cantons/ZG.svg';
import ZurichFlag from '../../../assets/images/cantons/ZH.svg';

export const CANTON_FLAGS: Record<CantonAbbr, string> = {
  AG: AargauFlag,
  AI: AppenzellInnerrhodenFlag,
  AR: AppenzellAusserrhodenFlag,
  BE: BernFlag,
  BL: BaselLandschaftFlag,
  BS: BaselStadtFlag,
  FR: FribourgFlag,
  GE: GeneveFlag,
  GL: GlarusFlag,
  GR: GraubundenFlag,
  JU: JuraFlag,
  LU: LuzernFlag,
  NE: NeuchatelFlag,
  NW: NidwaldenFlag,
  OW: ObwaldenFlag,
  SG: StGallenFlag,
  SH: SchaffhausenFlag,
  SO: SolothurnFlag,
  SZ: SchwyzFlag,
  TG: ThurgauFlag,
  TI: TicinoFlag,
  UR: UriFlag,
  VD: VaudFlag,
  VS: WallisFlag,
  ZG: ZugFlag,
  ZH: ZurichFlag,
} as const;

export interface CantonFlagProps {
  /**
   * The canton code for which the flag should be displayed.
   * If not provided, an empty flag will be shown.
   */
  canton?: CantonAbbr;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps<Theme>;
}

const CantonFlag = (props: CantonFlagProps) => {
  const { canton } = props;

  const flagImage = canton ? CANTON_FLAGS[canton] : null;

  return (
    <Box display='flex' {...props}>
      <Box component='img' src={flagImage ?? EmptyFlag} alt={canton} width='100%' />
    </Box>
  );
};

export default CantonFlag;
